import * as React from 'react';
import Header from '../Header/Header';
import DashboardButtonContainer from '../DashboardButton/DashboardButtonContainer';
import Strings from '../../globals/Strings';
import {ControlButton, TscButtonType} from '@techsmith/tsc-cloud-style-guide';
import TermsOfServiceText from './TermsOfServiceText';
import HeaderLogo from '../HeaderLogo/HeaderLogo';
import SettingsAndAccountWidget from '../SettingsAndAccountWidget/SettingsAndAccountWidget';
import NotificationsClientPluginWrapperContainer from '../NotificationsClientPluginWrapper/NotificationsClientPluginWrapperContainer';

export default () => {
   const headerLeft = <DashboardButtonContainer/>;
   const headerMiddle = <HeaderLogo linkToRoot={true}/>;
   const headerRight = <React.Fragment>
      <NotificationsClientPluginWrapperContainer/>
      <SettingsAndAccountWidget />
   </React.Fragment>;

   return (
      <div className="terms-of-service-container">
         <Header leftSection={headerLeft} middleSection={headerMiddle} rightSection={headerRight}/>
         <div className="terms-of-service-wrapper">
            <h1 className="title">{Strings.termsOfService.title}</h1>
            <div className="terms-of-service">
                <h2 className="terms-title">{Strings.termsOfService.subTitle}</h2>
                <p className="description">{Strings.termsOfService.description}</p>
                <TermsOfServiceText />
                <span className="print-button-container">
                <ControlButton buttonType={TscButtonType.secondary}
                                isFullWidth={true}
                                label={Strings.termsOfService.button.print}
                                onClick={window.print} />
                </span>
            </div>
         </div>
      </div>
   );
};
